import { render, staticRenderFns } from "./marathon_HengqinMara.vue?vue&type=template&id=dd9c2bc4"
import script from "./marathon_HengqinMara.vue?vue&type=script&lang=js"
export * from "./marathon_HengqinMara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports